<form [formGroup]="filterHandler.filtersForm" novalidate>
	<span [mat-sort-header]="column.propertyCode">{{ column.header }}</span>
</form>
